import { z } from "zod";
const externalId = z.string().regex(/^[1-9]\d{0,15}$/u);
/** A CRM application and an explicit owner decision; neither is a customer message. */
export const OwnerNewApplicationInputSchema = z.object({
    conversationId: z.string().uuid(), signalId: z.string().uuid(),
    applicationOccurredAt: z.string().datetime({ offset: true }),
    stageEntryAt: z.string().datetime({ offset: true }),
    leadExternalId: externalId, contactExternalId: externalId,
    providerRouteId: z.string().uuid(), externalChatRef: z.string().regex(/^[1-9]\d{4,19}$/u),
    stageExternalId: z.literal("80997658"), responsibleUserExternalId: externalId,
    expectedRevision: z.number().int().nonnegative(), expectedManagerFence: z.number().int().nonnegative(),
    ownerDecisionRef: z.string().trim().min(5).max(200),
    intention: z.string().trim().min(5).max(600), reason: z.string().trim().min(5).max(600),
}).strict();
export const OwnerNewApplicationProvenanceSchema = z.object({
    recoveryId: z.string().uuid(), sourceKind: z.literal("confirmed_crm_new_application"),
    signalId: z.string().uuid(), occurredAt: z.string().datetime({ offset: true }),
    stageEntryAt: z.string().datetime({ offset: true }), ownerDecisionRef: z.string().min(5).max(200),
}).strict();
//# sourceMappingURL=owner-new-application.js.map